import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

const STEP_FLOW_PATHS = 'checkin|checkout|breakdown|login|reopen';

/**
 * Converts a step key to URL-friendly slug
 * CUSTOMER_INFO → customer-info
 */
export const toUrlSlug = (stepKey: string): string =>
  stepKey.toLowerCase().replace(/_/g, '-');

/**
 * Converts a URL slug back to step key
 * customer-info → CUSTOMER_INFO
 */
export const fromUrlSlug = (slug: string): SelfServiceSteps =>
  slug.toUpperCase().replace(/-/g, '_') as SelfServiceSteps;

/**
 * Builds a step URL with preserved query params
 */
export const buildStepUrl = (
  basePath: string,
  stepKey: string,
  searchParams?: URLSearchParams | string
): string => {
  const slug = toUrlSlug(stepKey);
  const search = typeof searchParams === 'string'
    ? searchParams
    : searchParams?.toString();
  return `${basePath}/${slug}${search ? `?${search}` : ''}`;
};

export const getBasePath = (pathname: string): string => {
  const match = pathname.match(new RegExp(`^/(${STEP_FLOW_PATHS})`));
  return match ? `/${match[1]}` : '';
};

export const getStepSlugFromPath = (pathname: string): string | null => {
  const match = pathname.match(new RegExp(`^/(${STEP_FLOW_PATHS})/([^/?]+)`));
  return match ? match[2] : null;
};

/**
 * Extracts the step key from a self-service URL
 * /checkin/customer-info → CUSTOMER_INFO
 */
export const getStepFromPath = (pathname: string): SelfServiceSteps | null => {
  const slug = getStepSlugFromPath(pathname);
  return slug ? fromUrlSlug(slug) : null;
};
